import { render, staticRenderFns } from "./CurrentList.vue?vue&type=template&id=35d80118"
import script from "./CurrentList.vue?vue&type=script&lang=js"
export * from "./CurrentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports